function somInitBrandGallery() {
    if( document.querySelector(".brand-gallery") ) {
    let splide = new Splide('.brand-gallery', {
        perPage: 7,
        type: 'loop',
        pagination: false,
        speed: 860,
        arrows: false,
        lazyLoad: "nearby",
        drag: 'free',
        focus: 'center',
        gap: '100px',
        autoScroll: {
            speed: 0.5,
            pauseOnHover: false,
        },
        mediaQuery: 'max',
        breakpoints: {
            1690: {
                perPage: 5,
            },
            1123: {
                perPage: 4,
            },
            650: {
                perPage: 3,
                gap: '50px',
            },
        }
    });

    splide.on('ready', function () {
        document.querySelector('.brand-gallery').classList.add('is-active');
    });

    splide.mount(window.splide.Extensions);
    }
}

document.addEventListener("DOMContentLoaded", () => {
   somInitBrandGallery();

    if(document.querySelector("a[href='#openreservation']")) 
        document.querySelector("a[href='#openreservation']").addEventListener('click', e => {
            e.preventDefault();
            document.querySelector(".reservision-start > div").click();
        })

    animatePreloader();
})

function animatePreloader() {
    const pre = document.querySelector(".preloader");
    if( !pre ) return;

        const inner = pre.querySelector(".inner");    
        pre.addEventListener('transitionend', (e) => {
           if (e.target === inner) {
                setTimeout(() => {
                    inner.style.transform = 'translateY(-15px)';
                    pre.style.opacity = '0';  
                }, 1000);                
            }

            if (e.target === pre) {                
                pre.style.display = 'none';
            }
        });        

        setTimeout(() => {
            inner.style.opacity = '1';
            inner.style.transform = 'translateY(0)';
        }, 300);     
}